import { useMutation, UseMutationResult } from '@tanstack/react-query'
import {
  batchDeleteSeriesLabelsSeriesLabelsBatchDeletePost,
  createSeriesLabelSeriesLabelsPost,
  deleteSeriesLabelSeriesLabelsSeriesLabelIdDelete,
  updateSeriesLabelSeriesLabelsSeriesLabelIdPut,
} from '@common/config/api/client/services.gen'
import { AxiosError } from 'axios'
import {
  BatchDeleteSeriesLabelsSeriesLabelsBatchDeletePostResponse,
  CreateSeriesLabelsSchema,
  DeleteSeriesLabelSeriesLabelsSeriesLabelIdDeleteResponse,
  HTTPValidationError,
  SeriesLabelRecord,
  UpdateSeriesLabelsSchema,
} from '@common/config/api/client'

export const useDeleteSeriesLabel = (): UseMutationResult<
  DeleteSeriesLabelSeriesLabelsSeriesLabelIdDeleteResponse,
  AxiosError<HTTPValidationError>,
  string
> => {
  return useMutation<DeleteSeriesLabelSeriesLabelsSeriesLabelIdDeleteResponse, AxiosError<HTTPValidationError>, string>(
    {
      mutationFn: async (seriesLabelId: string) => {
        const response = await deleteSeriesLabelSeriesLabelsSeriesLabelIdDelete({
          path: { series_label_id: seriesLabelId },
          throwOnError: true,
        })
        return response.data
      },
    },
  )
}

export const useBulkDeleteSeriesLabels = (): UseMutationResult<
  BatchDeleteSeriesLabelsSeriesLabelsBatchDeletePostResponse,
  AxiosError<HTTPValidationError>,
  Array<string>
> => {
  return useMutation<
    BatchDeleteSeriesLabelsSeriesLabelsBatchDeletePostResponse,
    AxiosError<HTTPValidationError>,
    Array<string>
  >({
    mutationFn: async (seriesLabelIds: Array<string>) => {
      const response = await batchDeleteSeriesLabelsSeriesLabelsBatchDeletePost({
        body: { series_labels_ids: seriesLabelIds },
        throwOnError: true,
      })
      return response.data
    },
  })
}

export const useCreateSeriesLabel = (): UseMutationResult<
  SeriesLabelRecord,
  AxiosError<HTTPValidationError>,
  CreateSeriesLabelsSchema
> => {
  return useMutation<SeriesLabelRecord, AxiosError<HTTPValidationError>, CreateSeriesLabelsSchema>({
    mutationFn: async (seriesLabelPayload) => {
      const response = await createSeriesLabelSeriesLabelsPost({
        body: seriesLabelPayload,
        throwOnError: true,
      })
      return response.data
    },
  })
}

export const useUpdateSeriesLabel = (): UseMutationResult<
  SeriesLabelRecord,
  AxiosError<HTTPValidationError>,
  { seriesLabelId: string; seriesLabelPayload: UpdateSeriesLabelsSchema }
> => {
  return useMutation({
    mutationFn: async ({ seriesLabelId, seriesLabelPayload }) => {
      const response = await updateSeriesLabelSeriesLabelsSeriesLabelIdPut({
        path: { series_label_id: seriesLabelId },
        body: seriesLabelPayload,
        throwOnError: true,
      })
      return response.data
    },
  })
}
